import Attrition from './Attrition';

export default Attrition;
